export const REFERRAL_REQUEST = 'REFERRAL_REQUEST'
export const CHANGE_REFERRAL_DATA = 'CHANGE_REFERRAL_DATA'



// WEBPACK FOOTER //
// ./app/actions/auth/constants.js